import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_choice_toggle = _resolveComponent("ontos-choice-toggle")!

  return (_openBlock(), _createBlock(_component_ontos_choice_toggle, {
    "model-value": _ctx.modelValue,
    label: _ctx.label,
    options: [{value: false, ..._ctx.off}, {value: true, ..._ctx.on}],
    disabled: _ctx.disabled,
    "disabled-reason": _ctx.disabledReason,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, _createSlots({ _: 2 }, [
    (_ctx.modelValue && _ctx.$slots.default)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["model-value", "label", "options", "disabled", "disabled-reason"]))
}